/**
 * Navbar JavaScript functionality for KWE Sitepackage
 * 
 * This file handles Bootstrap component initialization and navbar-specific
 * functionality including dropdown menus, mobile menu, and accessibility features.
 * 
 * @author KWE Development Team
 * @version 1.0.0
 */

// Import specific Bootstrap components needed for navbar functionality
import { Dropdown, Collapse } from 'bootstrap';

/**
 * Initialize Bootstrap dropdown components
 * Required for navbar dropdown menus (Die KWE, Kontakt)
 */
function initializeDropdowns() {
    // Find all dropdown toggle elements
    const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
    
    if (dropdownElementList.length === 0) {
        console.log('No dropdown elements found');
        return [];
    }
    
    // Initialize Bootstrap Dropdown for each element
    const dropdownList = [...dropdownElementList].map(dropdownToggleEl => {
        return new Dropdown(dropdownToggleEl, {
            // Enable keyboard navigation
            autoClose: true,
            boundary: 'clippingParents',
            // Prevent dropdown from closing when clicking inside
            popperConfig: {
                strategy: 'fixed'
            }
        });
    });
    
    console.log(`Initialized ${dropdownList.length} dropdown components`);
    return dropdownList;
}

/**
 * Initialize Bootstrap collapse component for mobile navbar
 * Required for hamburger menu functionality on mobile devices
 */
function initializeCollapseComponent() {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('#navbarNav');
    
    if (!navbarToggler || !navbarCollapse) {
        console.log('Navbar toggler or collapse element not found');
        return null;
    }
    
    // Initialize collapse component
    const collapseInstance = new Collapse(navbarCollapse, { 
        toggle: false 
    });
    
    console.log('Initialized navbar collapse component');
    return collapseInstance;
}

// Export the initialization functions for use in other modules
export {
    initializeDropdowns,
    initializeCollapseComponent
};